<template>
  <v-content>
    <v-container fluid style="position: relative">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-container fluid>
              <v-card-title v-if="!quiz_id">{{
                "Add Quiz" | translate
              }}</v-card-title>
              <v-card-title v-if="quiz_id">{{
                "Edit Quiz" | translate
              }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-form id="form" ref="form">
                  <v-row>
                    <v-col cols="12" sm="8" md="8">
                      <v-row v-if="errors">
                        <v-col cols="12" sm="12" md="12">
                          <v-alert
                            dense
                            v-for="(v, k) in errors"
                            :key="k"
                            outlined
                            type="error"
                            >{{ k }} {{ v }}</v-alert
                          >
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            outlined
                            :label="'Quiz name' | translate"
                            v-model="quiz_name"
                            name="quiz_name"
                            autocomplete="off"
                            :rules="quiznameRules"
                            required
                          >
                            <template #message="{ message }">
                              {{
                                curLanguage.lang_code == "en"
                                  ? message
                                  : $t(message)
                              }}
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-textarea
                            outlined
                            name="quiz_description"
                            v-model="quiz_description"
                            autocomplete="off"
                            :label="'Quiz Description' | translate"
                            :rules="quizDescriptionRules"
                          >
                            <template #message="{ message }">
                              {{
                                curLanguage.lang_code == "en"
                                  ? message
                                  : $t(message)
                              }}
                            </template>
                          </v-textarea>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12">
                          <v-autocomplete
                            v-model="question_topics"
                            item-value="question_topic_id"
                            item-text="question_topic"
                            name="question_topics"
                            :items="questiontopicdata"
                            :label="'Question Topic' | translate"
                            :rules="questionTopicRules"
                            @change="questionTopicUpdated()"
                            outlined
                            autocomplete="off"
                            chips
                            multiple
                            small-chips
                          >
                            <template #message="{ message }">
                              {{
                                curLanguage.lang_code == "en"
                                  ? message
                                  : $t(message)
                              }}
                            </template>
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row v-if="this.question_topics">
                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete
                            v-model="question_data"
                            :items="questions"
                            item-value="question_id"
                            item-text="question_text"
                            :label="'Select Questions' | translate"
                            outlined
                            chips
                            multiple
                            small-chips
                            @change="questionsSelected()"
                            :no-data-text="$t('No data available')"
                          >
                            <template v-slot:selection="data">
                              <v-chip
                                v-bind="data.attrs"
                                :input-value="data.selected"
                                close
                                @click="data.select"
                                @click:close="remove(data.item)"
                              >
                              {{ data.item.question_name }}
                              </v-chip>
                            </template>
                            <template v-slot:item="data">
                              <template>
                                <v-list-item-content style="max-width: 500px;">
                                  <v-list-item-title 
                                    v-show="!active"
                                    @mouseover="mouseOverList"
                                    @mouseleave="mouseLeaveList"
                                    v-text="data.item.question_name"
                                  ></v-list-item-title>
                                  <v-list-item-title v-show="active"
                                   @mouseover="mouseOverList"
                                    @mouseleave="mouseLeaveList"
                                    v-text="data.item.question_text"
                                  ></v-list-item-title>
                                </v-list-item-content>
                                <v-chip-group>
                                  <v-chip
                                    class="ma-2"
                                    small
                                    v-for="(qt, i) in data.item.question_topics"
                                    :key="i"
                                  >
                                    {{ qt.question_topic }}
                                  </v-chip>
                                </v-chip-group>
                              </template>
                            </template>

                            <template #message="{ message }">
                              {{
                                curLanguage.lang_code == "en"
                                  ? message
                                  : $t(message)
                              }}
                            </template>
                          </v-autocomplete>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="4">
                          <v-text-field
                            outlined
                            autocomplete="off"
                            name="passing_percentage"
                            v-model="passing_percentage"
                            :rules="passingRules"
                            :label="'Passing Percent(%)' | translate"
                            required
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-switch
                            v-model="is_rand_question"
                            inset
                            :label="`Has Randomized Subset` | translate"
                          ></v-switch>
                        </v-col>

                        <v-col cols="12" sm="4" v-if="is_rand_question == true">
                          <v-text-field
                            outlined
                            autocomplete="off"
                            name="rand_question_count"
                            v-model="rand_question_count"
                            :rules="questionCountRules"
                            @change="questionMandatory"
                            :label="'Randomized Question Count' | translate"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row v-if="question_pool.length">
                        <v-col cols="12">
                          <v-card-text
                            class="pb-4 title"
                            style="cursor: pointer"
                            hint="a hint"
                            >{{ "Questions Selected" | translate }}
                          </v-card-text>
                           <v-card-subtitle class="mb-n5 mt-n4">
                            <div>
                              <v-alert text type="info" dense>
                                {{ question_message }}</v-alert
                              >
                            </div></v-card-subtitle
                          >
                        </v-col>
                      </v-row>

                      <v-row v-if="question_pool.length">
                        <v-col cols="12">
                          <v-data-table
                            :headers="Quizheaders"
                            :items="question_pool"
                            item-key="temp_id"
                            class="elevation-1"
                            :footer-props="{
                              'items-per-page-text': footertext,
                              itemsPerPageOptions: [
                                5,
                                10,
                                20,
                                { text: $t('All'), value: -1 },
                              ],
                            }"
                          >
                            <template slot="no-data">
                              {{ "No data available" | translate }}
                            </template>

                            <template v-if="is_rand_question == true"
                              v-slot:item.is_mandatory_question="{ item }"
                            >
                              <td
                                style="
                                  border-bottom: 0px solid rgba(0, 0, 0, 0.12);
                                "
                              >
                                <v-switch
                                  v-model="item.is_mandatory_question"
                                  inset
                                  :label="`${
                                    item.is_mandatory_question ? 'YES' : 'NO'
                                  }`"
                                  @change="questionMandatory"
                                ></v-switch>
                              </td>
                            </template>
                            <template
                              v-slot:item.question.question_topics="{ item }"
                            >
                              <td
                                style="
                                  border-bottom: 0px solid rgba(0, 0, 0, 0.12);
                                "
                              >
                                <v-chip-group column>
                                  <v-chip
                                    class="ma-2"
                                    small
                                    v-for="(qt, j) in item.question
                                      .question_topics"
                                    :key="j"
                                  >
                                    {{ qt.question_topic }}
                                  </v-chip>
                                </v-chip-group>
                              </td>
                            </template>

                            <template v-slot:footer.page-text="items">
                              {{ items.pageStart }} - {{ items.pageStop }}
                              {{ "of" | translate }} {{ items.itemsLength }}
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <v-col v-if="url != null" cols="12" sm="12">
                        <v-img
                          :src="url"
                          aspect-ratio="1"
                          class="grey lighten-2"
                          max-width="500"
                          max-height="300"
                        ></v-img>
                      </v-col>

                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-file-input
                            id="quiz_image"
                            name="filename"
                            outlined
                            chips
                            required
                            :label="'Quiz image' | translate"
                            @change="onFileSelected"
                          >
                            <template #message="{ message }">
                              {{
                                curLanguage.lang_code == "en"
                                  ? message
                                  : $t(message)
                              }}
                            </template>
                          </v-file-input>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete
                            v-model="quiz_language"
                            :items="quizLanguage"
                            item-value="value"
                            item-text="text"
                            :label="'Quiz Language' | translate"
                            :rules="quizLanguageRules"
                            outlined
                            chips
                            small-chips
                            required
                            :no-data-text="$t('No data available')"
                          >
                            <template #message="{ message }">
                              {{
                                curLanguage.lang_code == "en"
                                  ? message
                                  : $t(message)
                              }}
                            </template>
                          </v-autocomplete>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete
                            v-model="quiz_type"
                            :items="quizType"
                            item-value="value"
                            item-text="text"
                            :label="'Quiz Type' | translate"
                            :rules="quizTypeRules"
                            @change="quizTypeUpdated()"
                            outlined
                            chips
                            small-chips
                            required
                            :no-data-text="$t('No data available')"
                          >
                            <template #message="{ message }">
                              {{
                                curLanguage.lang_code == "en"
                                  ? message
                                  : $t(message)
                              }}
                            </template>
                          </v-autocomplete>
                        </v-col>
                      </v-row>

                      <v-row v-if="this.quiz_type == 'course'">
                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete
                            v-if="this.quiz_type == 'course'"
                            v-model="courses_data"
                            :items="courses"
                            item-value="course_id"
                            item-text="course_name"
                            :label="'Courses' | translate"
                            outlined
                            chips
                            small-chips
                            :no-data-text="$t('No data available')"
                          >
                            <template #message="{ message }">
                              {{
                                curLanguage.lang_code == "en"
                                  ? message
                                  : $t(message)
                              }}
                            </template>
                          </v-autocomplete>
                        </v-col>
                      </v-row>

                      <v-row v-if="this.quiz_type == 'module'">
                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete
                            v-if="this.quiz_type == 'module'"
                            v-model="module_data"
                            :items="modules"
                            item-value="module_id"
                            item-text="title"
                            :label="'Modules' | translate"
                            outlined
                            chips
                            multiple
                            small-chips
                            :no-data-text="$t('No data available')"
                          >
                            <template #message="{ message }">
                              {{
                                curLanguage.lang_code == "en"
                                  ? message
                                  : $t(message)
                              }}
                            </template>
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-form>
                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  class="mx-2"
                  v-if="quiz_id != ''"
                  @click="submit"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  class="mx-2"
                  v-if="quiz_id"
                  @click="update"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>

      <v-overlay :value="showLoader">
        <v-layout row justify-center v-if="showLoader">
          <v-dialog
            v-model="showLoader"
            persistent
            fullscreen
            content-class="loading-dialog"
          >
            <v-container fill-height>
              <v-layout row justify-center align-center>
                <v-progress-circular
                  :size="50"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </v-layout>
            </v-container>
          </v-dialog>
        </v-layout>
      </v-overlay>
    </v-container>
  </v-content>
</template>

<script>
import {
  ADD_QUIZ,
  RESET_STATE,
  FETCH_INDIVIDUAL_QUIZ,
  FETCH_QUESTION_TOPIC,
  UPDATE_QUIZ,
  FETCH_COURSES,
  FETCH_MODULES,
  FETCH_QUESTION,
} from "@/store/actions.type";
import {
  SET_SNACKBAR,
  SET_LOADING,
  SET_ROUTER_ENTER,
} from "@/store/mutations.type";
import store from "@/store";
import { mapState } from "vuex";
import { mapGetters } from "vuex";
export default {
  name: "addeditQuiz",
  async beforeRouteUpdate(to, from, next) {
    await store.dispatch(RESET_STATE);
    return next();
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch(RESET_STATE);
    await store.dispatch(FETCH_QUESTION_TOPIC, "");
    if (to.params.id) {
      await store.dispatch(FETCH_INDIVIDUAL_QUIZ, to.params.id).then((resp) => {
        if (resp.success) {
          store.commit(SET_LOADING, false);
          store.commit(SET_ROUTER_ENTER, false);
        }
      });
    }
    return next();
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(RESET_STATE);
    next();
  },
  computed: {
    ...mapGetters([
      "individualquiz",
      "questiontopicdata",
      "currentUser",
      "curLanguage",
    ]),
    ...mapState({
      errors: (state) => state.quiz.quizerrors,
      curLanguage: (state) => state.translations.curLanguage,
    }),
    Quizheaders() {
      if(this.is_rand_question == true){
        return [
                { text: this.$t("Is Mandatory"), value: "is_mandatory_question" },
                { text: this.$t("Topic"), value: "question.question_topics" },
                { text: this.$t("Question"), value: "question.question_text" },
                { text: this.$t("Order Index"), value: "order_index" },
              ];
      }else{
        return [
                { text: this.$t("Topic"), value: "question.question_topics" },
                { text: this.$t("Question"), value: "question.question_text" },
                { text: this.$t("Order Index"), value: "order_index" },
              ];
      }
     
    },
    footertext() {
      return this.$t("Rows per page");
    },
    quiznameRules() {
      return [(v) => !!v || "Quiz name is required"];
    },
    quizDescriptionRules() {
      return [(v) => !!v || "Quiz help text is required"];
    },
    quizLanguageRules() {
      return [(v) => !!(v && v.length) || "Language is required"];
    },
    quizTypeRules() {
      return [(v) => !!(v && v.length) || "Quiz Type is required"];
    },
    questionTopicRules() {
      return [
        (v) => !!(v && v.length) || "At least one Question Topic is required",
      ];
    },
    quizType() {
      return [
        { value: "module", text: this.$t("Module") },
        { value: "course", text: this.$t("Course") },
      ];
    },
    quizLanguage() {
      return [
        { value: "de", text: this.$t("German") },
        { value: "en", text: this.$t("English") },
      ];
    },
    orderIndexRules() {
      return [
        (v) =>
          Number.isInteger(Number(v)) || "The value must be an integer number",
      ];
    },
    questionCountRules() {
      return [
        (v) =>
          Number.isInteger(Number(v)) ||
          "The value must be a positive number and less than or equal to" +
            Object.keys(this.question_pool).length,
        (v) =>
          v <= Object.keys(this.question_pool).length ||
          "The value must be less than or equal to " +
            Object.keys(this.question_pool).length,
      ];
    },
    passingRules() {
      return [
        (v) => !!v || "Passing Percent is required",
        (v) =>
          Number.isInteger(Number(v)) || "The value must be a positive number",
      ];
    },
  },
  created() {
    this.questiontopicdata.forEach((item) => {
      this.topicDataNames.push({ question_topic: item.question_topic });
    });

    if (Object.keys(this.individualquiz).length > 0) {
      this.quiz_id = this.individualquiz.quiz_id;
      this.quiz_name = this.individualquiz.quiz_name;
      this.quiz_description = this.individualquiz.quiz_description;
      this.quiz_language = this.individualquiz.quiz_language;
      this.quiz_type = this.individualquiz.quiz_type;
      this.quizTypeUpdated();
      if (this.individualquiz.quiz_type == "module") {
        this.module_data = this.individualquiz.modules;
      } else {
        this.courses_data = this.individualquiz.course_id;
      }
      this.question_topics = this.individualquiz.question_topics;

      this.questions = this.individualquiz.questions;
      this.individualquiz.questions.forEach((item) => {
        this.question_data.push(item.question_id);
      });
      this.question_pool = [];
      this.question_data.forEach((question_id) => {
        this.question_pool.push({
          question_id: question_id,
          question: this.questions.find((x) => x.question_id === question_id),
          order_index: this.question_pool.length + 1,
          is_mandatory_question: this.individualquiz.questions.find(
            (z) => z.question_id === question_id
          ).is_mandatory_question,
        });
      });
      this.is_rand_question = this.individualquiz.is_rand_question;
      this.rand_question_count = this.individualquiz.rand_question_count;
      this.passing_percentage = this.individualquiz.passing_percentage;
      this.url =
        process.env.VUE_APP_COMPANYADMIN_STORAGE_URL +
        this.individualquiz.quiz_image;

      this.questionTopicUpdated();
      this.questionMandatory();
    }
  },
  mounted() {
    let company_meta = JSON.parse(this.currentUser.company.company_meta);
    this.primary_color = company_meta.primary_color;
  },
  data: function () {
    return {
      quiz_name: null,
      quiz_id: null,
      quiz_type: null,
      quiz_language: null,
      quiz_description: null,
      courses: [],
      courses_data: [],
      modules: [],
      module_data: [],
      questions: [],
      topic_questions: [],
      question_data: [],
      question_pool: [],
      topicDataNames: [],
      question_message: null,
      mandatory_question_count: 0,
      is_rand_question: false,
      rand_question_count: 0,
      passing_percentage: null,
      max: 0,
      primary_color: null,
      question_topics: [],
      question_topic: null,
      file: null,
      status: null,
      url: null,
      show: false,
      showLoader: false,
      active: false,
    };
  },
  methods: {
    remove(item) {
      const index = this.question_data.indexOf(item.question_id);
      if (index >= 0) this.question_data.splice(index, 1);
      this.questionsSelected();
    },
    mouseLeaveList(){
      this.active = false;   
    },
    mouseOverList(){
      this.active = true;   
    },
    async quizTypeUpdated() {
      if (this.quiz_type == "course") {
        this.courses_data = [];
        /*fetch courses for the company*/
        await store.dispatch(FETCH_COURSES, "").then((resp) => {
          if (resp.success) {
            this.courses = resp.data;
            store.commit(SET_LOADING, false);
            store.commit(SET_ROUTER_ENTER, false);
          }
        });
      } else {
        //fetch modules for the company
        this.module_data = [];
        await store.dispatch(FETCH_MODULES, "").then((resp) => {
          if (resp.success) {
            this.modules = resp.data;
            store.commit(SET_LOADING, false);
            store.commit(SET_ROUTER_ENTER, false);
          }
        });
      }
    },
    async questionTopicUpdated() {
      if (this.question_topics.length == 0) {
        return;
      }
      await store
        .dispatch(FETCH_QUESTION, "?question_topic_ids=" + this.question_topics)
        .then((resp) => {
          this.topic_questions = resp.data;
          this.oldquestions = [];

          this.question_data.forEach((id) => {
            this.oldquestions.push(
              this.questions.find((x) => x.question_id === id)
            );
          });

          this.questions = [];
          this.oldquestions.forEach((item) => {
            this.questions.push(item);
          });

          this.topic_questions.forEach((item) => {
            if (
              !this.questions.find((x) => x.question_id === item.question_id)
            ) {
              this.questions.push(item);
            }
          });
        });
    },
    questionsSelected() {
      this.question_pool = [];
      this.question_data.forEach((question_id) => {
        this.question_pool.push({
          question_id: question_id,
          question: this.questions.find((x) => x.question_id === question_id),
          order_index: this.question_pool.length + 1,
          is_mandatory_question: false,
        });
      });
      this.question_message =
        "Quiz contains a total of " +
        this.question_pool.length +
        (this.question_pool.length == 1
          ? " Question. Out of which "
          : " Questions. Out of which ") + 
          (this.rand_question_count?(parseFloat(this.mandatory_question_count)+parseFloat(this.rand_question_count)):this.question_pool.length)
         +
          (this.rand_question_count?((parseFloat(this.mandatory_question_count)+parseFloat(this.rand_question_count))==1?" Question will be shown, ":" Questions will be shown, "):(this.question_pool.length==1)?" Question will be shown, ":" Questions will be shown, ")
          + this.mandatory_question_count +
        (this.mandatory_question_count == 1
          ? " is a Mandatory Question and "
          : " are Mandatory Questions and ") + (this.rand_question_count?this.rand_question_count:' no ') +
          (this.rand_question_count == 1
          ? " Question is randomized. "
          : " Questions are randomized. ");
    },
    onFileSelected() {
      this.file = document.getElementById("quiz_image").files[0];
      this.url = URL.createObjectURL(this.file);
    },
    questionMandatory() {
      this.mandatory_question_count = 0;
      this.question_pool.forEach((item) => {
        if (item.is_mandatory_question) {
          this.mandatory_question_count = this.mandatory_question_count + 1;
        }
      });
       this.question_message =
        "Quiz contains a total of " +
        this.question_pool.length +
        (this.question_pool.length == 1
          ? " Question. Out of which "
          : " Questions. Out of which ") + 
          (this.rand_question_count?(parseFloat(this.mandatory_question_count)+parseFloat(this.rand_question_count)):this.question_pool.length)
         +
          (this.rand_question_count?((parseFloat(this.mandatory_question_count)+parseFloat(this.rand_question_count))==1?" Question will be shown, ":" Questions will be shown, "):(this.question_pool.length==1)?" Question will be shown, ":" Questions will be shown, ")
          + this.mandatory_question_count +
        (this.mandatory_question_count == 1
          ? " is a Mandatory Question and "
          : " are Mandatory Questions and ") + (this.rand_question_count?this.rand_question_count:' no ') +
          (this.rand_question_count == 1
          ? " Question is randomized. "
          : " Questions are randomized. ");
    },
    maxQuestionpoints() {
      this.question_pool.forEach(function (item) {
        this.max = item.question.question_points + this.max;
      });
      return this.max;
    },
    submit: function () {
      if (this.$refs.form.validate()) {
        var formData = new FormData(document.getElementById("form"));
        formData.set("quiz_name", this.quiz_name);
        formData.set("quiz_description", this.quiz_description);
        formData.set("quiz_language", this.quiz_language);
        formData.set("quiz_type", this.quiz_type);
        if (this.quiz_type == "module") {
          this.module_data.forEach(function (item) {
            formData.append("modules[]", item);
          });
        } else {
          formData.set("course_id", this.courses_data);
        }
        if (this.file != null) {
          formData.set("quiz_image", this.file);
        }
        this.question_topics.forEach(function (item) {
          formData.append("question_topics[]", item);
        });
        let questions = this.question_pool.map((item) => {
          return {
            question_id: item.question_id,
            order_index: item.order_index,
            is_mandatory_question: item.is_mandatory_question,
          };
        });
        formData.set("questions", JSON.stringify(questions));
        formData.set("is_rand_question", this.is_rand_question ? "1" : "0");
        if (this.is_rand_question == true) {
          formData.set("rand_question_count", this.rand_question_count);
        }
        formData.set("passing_percentage", this.passing_percentage);
        this.$store.dispatch(ADD_QUIZ, formData).then((resp) => {
          if (
            resp != undefined &&
            resp.hasOwnProperty("success") &&
            resp.success
          ) {
            store.commit(SET_LOADING, false);
            store.commit(SET_SNACKBAR, {
              status: true,
              message: "Quiz created successfully",
            });
            this.$router.push({ name: "quiz" });
          } else {
            store.commit(SET_LOADING, false);
          }
        });
      }
    },
    update: function () {
      if (this.$refs.form.validate()) {
        var formData = new FormData(document.getElementById("form"));
        formData.set("quiz_id", this.quiz_id);
        formData.set("quiz_name", this.quiz_name);
        formData.set("quiz_description", this.quiz_description);
        formData.set("quiz_language", this.quiz_language);
        formData.set("quiz_type", this.quiz_type);
        if (this.quiz_type == "module") {
          this.module_data.forEach(function (item) {
            formData.append("modules[]", item);
          });
        } else {
          formData.set("course_id", this.courses_data);
        }
        if (this.file != null) {
          formData.set("quiz_image", this.file);
        }
        this.question_topics.forEach(function (item) {
          formData.append("question_topics[]", item);
        });

        let questions = this.question_pool.map((item) => {
          return {
            question_id: item.question_id,
            order_index: item.order_index,
            is_mandatory_question: item.is_mandatory_question,
          };
        });
        formData.set("questions", JSON.stringify(questions));

        formData.set("is_rand_question", this.is_rand_question ? "1" : "0");

        if (this.is_rand_question == true) {
          formData.set("rand_question_count", this.rand_question_count);
        }
        formData.set("passing_percentage", this.passing_percentage);
        formData.set("_method", "put");

        this.$store.dispatch(UPDATE_QUIZ, formData).then((resp) => {
          if (
            resp != undefined &&
            resp.hasOwnProperty("success") &&
            resp.success
          ) {
            store.commit(SET_LOADING, false);
            store.commit(SET_SNACKBAR, {
              status: true,
              message: "Quiz updated successfully",
            });
            this.$router.push({ name: "quiz" });
          } else {
            store.commit(SET_LOADING, false);
          }
        });
      }
    },
  },
};
</script>
